import React, { useCallback, useMemo } from 'react';
import { ResponsiveLine, SliceTooltipProps } from '@nivo/line';

import { NivoLineSeries, Slice } from 'modules/insights';
import { NIVO_CHART_COLORS } from 'utils/analyticsHelpers';

import { SliceTooltipComponent } from './tooltips/sliceCustomTooltip';

export interface NivoLineChartProps {
    data: NivoLineSeries[];
    height?: number;
    truncateLabelAt?: number;
}

export const NivoLineChart: React.FC<NivoLineChartProps> = ({
    data,
    truncateLabelAt,
    height = 280,
}) => {

    const truncate = useCallback((id: string | number) => {
        const label = String(id);
        return truncateLabelAt && label.length > truncateLabelAt
            ? label.slice(0, truncateLabelAt) + '… '
            : label;
    }, [truncateLabelAt]);

    const TooltipWithTruncation = useMemo(() => ({ slice }: SliceTooltipProps) => (
        <SliceTooltipComponent slice={{
            ...slice,
            points: slice.points.map(p => ({ ...p, serieId: truncate(p.serieId) }))
        } as Slice} />
    ), [truncate]);

    return (
        <div
            style={{
                height: height,
                width: '100%',
                overflowX: 'auto',
                overflowY: 'hidden'
            }}>
                <ResponsiveLine
                    data={data}
                    sliceTooltip={TooltipWithTruncation}
                    colors={NIVO_CHART_COLORS}
                    margin={{ top: 20, right: 180, bottom: 40, left: 50 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false, nice: true }}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: '',
                        legendOffset: 36,
                        legendPosition: 'middle'
                    }}
                    axisLeft={{
                        tickSize: 0,
                        tickPadding: 0,
                        tickRotation: 0,
                        legend: '',
                        legendOffset: -30,
                        legendPosition: 'middle',
                        format: () => ''
                    }}
                    curve="linear"
                    enableArea={false}
                    pointSize={6}
                    pointColor={{ theme: 'background' }}
                    pointBorderWidth={2}
                    pointBorderColor={{ from: 'serieColor' }}
                    useMesh={true}
                    enableSlices="x"
                    legends={[
                        {
                            anchor: 'top-right',
                            direction: 'column',
                            translateX: 120,
                            translateY: -25,
                            itemWidth: 80,
                            itemHeight: 22,
                            symbolShape: 'square',
                            data: data.map((series, index) => ({
                                id: series.id,
                                label: truncate(series.id),
                                color: NIVO_CHART_COLORS[index % NIVO_CHART_COLORS.length],
                            })),
                        }
                    ]}
                    //Hides the weird background grid lines
                    gridYValues={[]}
                    gridXValues={[]}
                    
                />
        </div>
    );
};